/**
 * @name classify
 * @description Convert a string into a CSS class representation
 */
export const classify = (string: string): string =>
  string.replace(/[^\w\d]/g, '-').replace(/-{2,}/, '-');
